import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter-idling",
  "use": "icon-filter-idling-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter-idling\">\r\n<path d=\"M6.5 6.5H5.5V3.5H6.5M5.5 7.5H6.5V8.5H5.5M7.865 1.5H4.135L1.5 4.135V7.865L4.135 10.5H7.865L10.5 7.865V4.135L7.865 1.5Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol